import { useQuery } from '@tanstack/react-query'

import useAuth from 'hooks/useAuth'
import { ACCESS_PROFILE_CASE_CONVERSION_EXCLUDE, AccessProfile } from 'types/access-profile'
import axiosServices from 'utils/axios'
import { camelCaseKeys } from 'utils/case-conversion'

const fetchAccessProfiles = async (businessId?: number): Promise<AccessProfile[]> => {
  const response = await axiosServices.get(`/businesses/${businessId}/access_profiles`)

  return camelCaseKeys(response.data, ACCESS_PROFILE_CASE_CONVERSION_EXCLUDE) as AccessProfile[]
}

export const useFetchAccessProfiles = () => {
  const { user } = useAuth()

  return useQuery({
    queryKey: ['fetch-access-profiles', user?.business_id],
    queryFn: () => fetchAccessProfiles(user?.business_id),
    retry: 2
  })
}
